import { createSelector } from "reselect"

import {
    selectWidgetDataSources,
    selectWidgetMeta,
} from "app/static/frontend/widgets/selectors/selectors"

// Bar Visualization shapes of type CountVisualizationWidget
// return either a number (1) or array of numbers ([1, 2]),
// so to properly display these in the Dashboard,
// we need to manually append an x-axis label
// (the label of the SafedSearch data_sources selection)
export const selectBarVisualizationData = createSelector(
    (state, props) => props.data,
    (state, props) => props.labels,
    selectWidgetDataSources,
    (data, labels, dataSources) => {
        // data: {
        //     [DjangIO.app.person.types.Party.Democrat.value]: { agg: 10 },
        //     [DjangIO.app.person.types.Party.Republican.value]: { agg: 20 },
        // },
        // or
        // data: [
        //     {
        //         [DjangIO.app.person.types.Party.Democrat.value]: { agg: 10 },
        //         [DjangIO.app.person.types.Party.Republican.value]: { agg: 20 },
        //     },
        //     {
        //         [DjangIO.app.person.types.Party.Democrat.value]: { agg: 30 },
        //         [DjangIO.app.person.types.Party.Republican.value]: { agg: 40 },
        //     },
        // ],
        if (!dataSources[0].count) {
            return data
        }

        // data: [1, 2, ...]
        if (Array.isArray(data)) {
            return data.map((datum, i) => ({
                [labels[i]]: {
                    agg: datum,
                    groupKeyValue: labels[i],
                },
            }))
        }

        // data: 1
        return {
            [labels[0]]: {
                agg: data,
                groupKeyValue: labels[0],
            }
        }
    }
)

// data groupKey used throughout the d3 renderers invoked in BarGrouped.jsx and BarStacked.jsx
// ex:
//    const groupKey = "name"
//    const data = [{ [groupKey]: "Lee (D-CA)", Science: 42, "Solar Cars": 15, Engineering: 8 }]
export const selectBarVisualizationGroupKey = () => "name"

// these keys used throughout the d3 renderers invoked in BarGrouped.jsx and BarStacked.jsx
// and must be unique to prevent key errors
export const selectBarVisualizationKeys = createSelector(
    (state, props) => props.labels,
    labels => (
        labels
            ? labels.map((label, index) => `${label}-${index}`)
            : []
    )
)

export const selectBarVisualizationDirection = createSelector(
    selectWidgetMeta,
    meta => (
        meta &&
        meta.vis_options.bar_visualization_direction
    )
)

export const selectBarVisualizationIsHorizontal = createSelector(
    selectBarVisualizationDirection,
    direction =>
        direction === DjangIO.app.widgets.types.BarVisualizationDirection.horizontal.value
)
